import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import styles from './style.module.scss'

const SkeletonLoaderPage: React.VFC = () => {
  return (
    <div className={styles.skeletonLoaderPage}>
      <div className={styles.skeletonLoaderPageMv}>
        <Skeleton
          height={350}
          borderRadius="8px"
          style={{ marginBottom: "3.2rem" }}
        />
      </div>
      <div className={styles.skeletonLoaderPageList}>
        <Skeleton
          height={100}
          borderRadius="8px"
          style={{ marginBottom: "1.2rem" }}
        />
        <Skeleton
          height={100}
          borderRadius="8px"
          style={{ marginBottom: "1.2rem" }}
        />
        <Skeleton
          height={250}
          borderRadius="8px"
          style={{ marginBottom: "1.2rem" }}
        />
      </div>
    </div>
  )
}

export { SkeletonLoaderPage }
